import React from "react";
var CopyLinkIcon = function CopyLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.066 16.983c.207-.207.31-.464.31-.773s-.104-.553-.31-.733l-2.278-2.28c-.18-.206-.438-.309-.773-.309-.283 0-.54.116-.772.348l.424.425c.078.077.142.154.193.232a.37.37 0 0 1 .117.27c.026.052.038.154.038.308 0 .31-.103.555-.309.735a1 1 0 0 1-.734.309 1.003 1.003 0 0 1-.309-.038 1.502 1.502 0 0 1-.27-.156.517.517 0 0 1-.136-.095c-.037-.04-.07-.06-.096-.06l-.425-.424c-.232.18-.347.438-.347.772 0 .336.102.593.309.774l2.24 2.278c.258.206.514.31.772.31.284 0 .528-.105.734-.31l1.622-1.583Zm-7.802-7.726a1.108 1.108 0 0 0 .348-.81c0-.31-.103-.554-.31-.735l-2.24-2.317c-.257-.207-.514-.309-.772-.309a1 1 0 0 0-.734.309l-1.62 1.622c-.207.18-.31.425-.31.734s.103.553.31.734l2.277 2.317c.207.207.465.31.773.31.284 0 .54-.116.773-.348 0-.026-.065-.103-.194-.232l-.424-.425c-.078-.129-.117-.218-.117-.27a1.004 1.004 0 0 1-.038-.309c0-.31.103-.566.31-.773a1.004 1.004 0 0 1 .734-.309c.052 0 .103.007.154.02.05.012.102.018.154.018.155.078.245.13.27.156l.232.154.232.232a.606.606 0 0 1 .116.155l.077.076h-.001ZM21.5 16.211c0 .926-.309 1.673-.927 2.24l-1.622 1.621a3.053 3.053 0 0 1-2.24.928c-.902 0-1.65-.31-2.241-.928l-2.279-2.317c-.618-.592-.927-1.339-.927-2.24 0-.902.322-1.661.966-2.279l-.966-.966c-.644.644-1.403.966-2.278.966-.902 0-1.662-.309-2.28-.927L4.43 9.99a3.052 3.052 0 0 1-.929-2.24c0-.875.31-1.622.928-2.24l1.62-1.622C6.643 3.297 7.389 3 8.29 3c.901 0 1.649.309 2.24.927l2.279 2.279c.619.617.928 1.364.928 2.24 0 .901-.323 1.674-.967 2.318l.966.966c.618-.644 1.378-.966 2.279-.966.902 0 1.662.308 2.28.927l2.277 2.278c.62.619.928 1.366.928 2.242Z",
    fill: "#fff"
  }));
};
CopyLinkIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { CopyLinkIcon };
var EmailIcon1 = function EmailIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.551 17.21h18.898A1.552 1.552 0 0 0 23 15.659V2.551A1.553 1.553 0 0 0 21.45 1H2.55A1.552 1.552 0 0 0 1 2.551v13.108a1.553 1.553 0 0 0 1.551 1.551Zm19.725-2.893-7.35-5.233 7.35-5.233v10.466ZM1.724 2.551a.827.827 0 0 1 .827-.827h18.898a.827.827 0 0 1 .827.827v.411l-.375.267-7.6 5.41-.312.223-.312.222-.493.351a2.041 2.041 0 0 1-2.368 0l-.493-.351-.312-.222-.312-.223-7.6-5.41-.375-.267v-.411Zm0 1.3 7.35 5.233-7.35 5.233V3.851Zm0 11.355.376-.267 7.599-5.41.697.496a2.767 2.767 0 0 0 3.208 0l.698-.496 7.6 5.41.374.267v.453a.827.827 0 0 1-.827.827H2.551a.828.828 0 0 1-.827-.827v-.453Z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: ".3"
  }));
};
EmailIcon1.defaultProps = {
  width: "24",
  height: "18",
  viewBox: "0 0 24 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { EmailIcon1 };
var EmailIcon = function EmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 10.06v8.082c0 .512-.196.95-.59 1.313a2.01 2.01 0 0 1-1.414.545H4.504c-.55 0-1.022-.182-1.415-.545-.392-.364-.589-.801-.589-1.313V10.06l10.02 4.12 9.98-4.12Zm0-1.252-9.98 4.162L2.5 8.808v-2.95c0-.511.197-.95.59-1.313A2.011 2.011 0 0 1 4.503 4h15.992c.55 0 1.022.182 1.415.545.393.364.589.802.589 1.314v2.95Z",
    fill: "#fff"
  }));
};
EmailIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { EmailIcon };
var LineIcon = function LineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.05 8.563a.215.215 0 0 1-.213.215h-2.096v.813h2.096c.118 0 .214.097.214.216v.774a.215.215 0 0 1-.214.215h-2.096v.813h2.096c.118 0 .214.097.214.216v.774a.215.215 0 0 1-.214.216h-3.083a.212.212 0 0 1-.15-.063l-.004-.004a.213.213 0 0 1-.06-.148V7.788c0-.058.023-.11.06-.149l.003-.004.002-.002a.213.213 0 0 1 .15-.06h3.082c.118 0 .214.096.214.216v.773ZM15.79 12.6a.214.214 0 0 1-.214.215h-.772a.215.215 0 0 1-.055-.008h-.002a.128.128 0 0 1-.015-.005c-.003 0-.004-.002-.006-.003l-.011-.004a.126.126 0 0 1-.01-.005l-.007-.003a.298.298 0 0 1-.07-.063l-2.197-2.983V12.6a.214.214 0 0 1-.215.215h-.771a.215.215 0 0 1-.215-.216v-4.81a.216.216 0 0 1 .215-.216h.778l.011.002h.012l.008.002c.005 0 .009.002.013.003l.008.002.013.004.006.003.013.005.007.003a.152.152 0 0 1 .017.01l.011.008a.12.12 0 0 1 .018.014l.004.004.013.012v.002a.201.201 0 0 1 .018.022l2.196 2.977V7.788a.215.215 0 0 1 .214-.215h.772a.216.216 0 0 1 .214.216v4.81Zm-5.31 0a.215.215 0 0 1-.215.215h-.772a.214.214 0 0 1-.214-.216v-4.81c0-.12.096-.216.214-.216h.772a.215.215 0 0 1 .214.216v4.81Zm-1.861 0a.215.215 0 0 1-.214.215H5.323a.213.213 0 0 1-.148-.06c-.002 0-.003-.003-.003-.003l-.004-.004a.215.215 0 0 1-.06-.148V7.788a.216.216 0 0 1 .215-.216h.772c.118 0 .214.097.214.216v3.82h2.096c.118 0 .214.097.214.216v.776ZM23.5 9.96C23.5 5.02 18.566 1 12.5 1c-6.065 0-11 4.02-11 8.961 0 4.43 3.914 8.14 9.2 8.841.358.078.846.238.969.544.11.28.072.718.035 1l-.157.944c-.048.28-.221 1.093.953.595 1.174-.495 6.334-3.744 8.643-6.41C22.735 13.72 23.5 11.939 23.5 9.96Z",
    fill: "#fff"
  }));
};
LineIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { LineIcon };
var FacebookIcon = function FacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.192 3.114v2.88h-1.765c-.68 0-1.113.126-1.296.379-.235.277-.353.67-.353 1.174v2.047h3.297l-.432 3.22h-2.865V21h-3.414v-8.185H7.5v-3.22h2.864v-2.35c0-1.315.38-2.362 1.138-3.146C12.313 3.367 13.36 3 14.642 3c1.072 0 1.922.038 2.55.114Z",
    fill: "#fff"
  }));
};
FacebookIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { FacebookIcon };
var FacebookMessengerIcon = function FacebookMessengerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1c-6.075 0-11 4.56-11 10.185 0 3.205 1.6 6.065 4.1 7.932V23l3.745-2.056c1 .277 2.058.426 3.155.426 6.075 0 11-4.56 11-10.185C23.5 5.56 18.575 1 12.5 1Zm.518 13.895-2.726-3.252-5.318 3.252 5.85-6.948 2.792 3.252 5.252-3.252-5.85 6.948Z",
    fill: "#fff"
  }));
};
FacebookMessengerIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { FacebookMessengerIcon };
var TelegramIcon = function TelegramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.226 11.533S10.072 8.24 13.14 7.08c1.175-.463 5.164-1.948 5.164-1.948s1.84-.649 1.687.928c-.051.65-.46 2.922-.87 5.38-.613 3.478-1.278 7.281-1.278 7.281s-.102 1.067-.971 1.252c-.87.186-2.3-.649-2.556-.834-.205-.14-3.835-2.227-5.165-3.247-.358-.278-.767-.835.051-1.484 1.841-1.53 4.04-3.432 5.37-4.638.613-.556 1.226-1.855-1.33-.278a442.328 442.328 0 0 1-7.21 4.406s-.818.464-2.352.046a114.412 114.412 0 0 1-3.323-.974s-1.227-.695.87-1.438Z",
    fill: "#fff"
  }));
};
TelegramIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { TelegramIcon };
var TwitterIcon = function TwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.235 8.851 16.699 2.5h-1.295L10.66 8.015 6.87 2.5H2.5l5.73 8.34L2.5 17.5h1.295l5.01-5.824 4.002 5.824h4.37l-5.942-8.649ZM9.46 10.913l-.58-.83-4.62-6.608h1.99l3.727 5.332.58.83 4.847 6.933h-1.99l-3.954-5.657Z",
    fill: "#fff"
  }));
};
TwitterIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
};
export { TwitterIcon };
var WhatsappIcon = function WhatsappIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.614 13.205c.168 0 .636.218 1.407.653.77.402 1.188.653 1.255.754.034.033.05.1.05.2 0 .302-.083.67-.25 1.106-.168.368-.503.686-1.005.954-.503.235-.988.352-1.457.352-.502 0-1.423-.285-2.762-.854a9.18 9.18 0 0 1-2.411-1.708c-.67-.67-1.373-1.557-2.11-2.662-.703-1.005-1.055-1.925-1.055-2.763v-.15c.067-.87.419-1.624 1.055-2.26.234-.201.486-.302.753-.302h.252c.1.034.2.05.301.05.2 0 .318.034.352.1.067.034.15.151.25.352 0 .067.06.243.177.528.117.284.209.544.276.778.234.603.351.955.351 1.055 0 .201-.15.469-.452.804-.335.335-.502.569-.502.703 0 .067.017.134.05.2a6.12 6.12 0 0 0 1.457 1.96 8.425 8.425 0 0 0 2.16 1.456c.2.067.318.1.351.1.134 0 .385-.234.754-.702.402-.47.653-.704.753-.704Zm-2.913 7.635a8.625 8.625 0 0 0 3.516-.753 8.585 8.585 0 0 0 2.863-1.909 8.585 8.585 0 0 0 1.909-2.863c.468-1.038.703-2.21.703-3.516 0-1.272-.235-2.428-.703-3.466-.47-1.138-1.105-2.11-1.91-2.913-.736-.737-1.69-1.373-2.862-1.909-1.206-.468-2.378-.703-3.516-.703-1.139 0-2.31.235-3.516.703-1.172.536-2.126 1.172-2.863 1.91-.804.803-1.44 1.774-1.909 2.912-.469 1.038-.703 2.194-.703 3.466 0 1.976.57 3.734 1.708 5.274l-1.155 3.365 3.465-1.105c1.574 1.005 3.232 1.507 4.973 1.507ZM12.7 1c1.406 0 2.813.285 4.22.854a10.628 10.628 0 0 1 3.415 2.31c.97.938 1.74 2.093 2.31 3.466.57 1.24.854 2.629.854 4.17 0 1.54-.285 2.946-.854 4.218-.57 1.34-1.34 2.495-2.31 3.466-.904.904-2.043 1.674-3.416 2.31-1.406.57-2.813.854-4.22.854a10.48 10.48 0 0 1-5.223-1.356L1.5 23.201l1.909-5.827c-1.005-1.64-1.507-3.499-1.507-5.574 0-1.54.284-2.93.854-4.169.569-1.373 1.34-2.528 2.31-3.466a10.628 10.628 0 0 1 3.416-2.311C9.888 1.284 11.295 1 12.7 1Z",
    fill: "#fff"
  }));
};
WhatsappIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { WhatsappIcon };
var PrintIcon = function PrintIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.111 3H5.89V5.57H18.11V3ZM3.25 6.857h17.5c.688 0 1.25.578 1.25 1.285v6.429c0 .707-.563 1.286-1.25 1.286h-2.639V21H5.89v-5.143H3.25c-.688 0-1.25-.579-1.25-1.286V8.142c0-.707.563-1.285 1.25-1.285Zm13.61 12.857H7.14v-6.428h9.722v6.428Zm3.265-9.996a.92.92 0 0 0 .906-.932.92.92 0 0 0-.906-.933.92.92 0 0 0-.906.933.92.92 0 0 0 .906.932Z",
    fill: "#fff"
  }));
};
PrintIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { PrintIcon };